import { Box, IconButton } from '@mui/material';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { useState } from 'react';
import useIsMobile from './hooks/useIsMobile';
import { RenderMode } from 'react-pdf/dist/cjs/shared/types';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

interface DocumentProps {
    file: string;
    height: number;
    pages: number;
}

function PageDocument(props: DocumentProps) {
    const isMobile = useIsMobile();
    const [pageNumber, setPageNumber] = useState(1);

    return (
        <Box
            sx={{
                position: 'relative',
            }}
        >
            {pageNumber > 1 &&
                <Box
                    sx={{
                        position: 'absolute',
                        top: '45%',
                        textShadow: '0 0 8px #000',
                        left: 0,
                        bottom: 0,
                        height: 'fit-content',
                        cursor: 'pointer',
                        zIndex: 5,
                    }}
                >
                    <IconButton
                        onClick={() => {
                            setPageNumber(Math.max(pageNumber - 1, 1));
                        }}
                    >
                        <ArrowBackIos
                            color="secondary"
                            sx={{
                                filter: 'drop-shadow(0 0 8px #000)',
                            }}
                        />
                    </IconButton>
                </Box>
            }
            {props.pages > pageNumber &&
                <Box
                    sx={{
                        position: 'absolute',
                        top: '45%',
                        right: 0,
                        textShadow: '0 0 8px #000',
                        bottom: 0,
                        height: 'fit-content',
                        cursor: 'pointer',
                        zIndex: 5,
                    }}
                >
                    <IconButton
                        onClick={() => {
                            setPageNumber(Math.min(pageNumber + 1, props.pages));
                        }}
                    >
                        <ArrowForwardIos
                            color="secondary"
                            sx={{
                                filter: 'drop-shadow(0 0 8px #000)',
                            }}
                        />
                    </IconButton>
                </Box>
            }
            <Document
                file={props.file}
                onLoadSuccess={() => {
                }}
            >
                <Page
                    pageNumber={pageNumber}
                    height={props.height}
                    renderMode={'svg' as RenderMode}
                />
            </Document>
        </Box>
    );
}

export default PageDocument;
